<div class="ui-dashboard" id="dashFwa">

  <div class="dashboard-wrapper m-b-30">

    <div class="p-b-10">
      <div class="grid grid-gap-20 grid-2x grid-2x-responsive p-b-20">

        <!-- LHS -->
        <div>
          <h2 class="dashboard-head">SLA Dashboard</h2>
        </div>

        <!-- RHS -->
        <div class="text-a-right">
          <nz-range-picker [(ngModel)]="dashboardDateRange" (ngModelChange)="onDashboardDateRangeSelection($event)"
            class="dash-date-range" [nzFormat]="appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR">
          </nz-range-picker>
        </div>

      </div>
    </div>
  </div>

  <div class="grid grid-2x grid-2x-responsive grid-gap-20">

    <div class="widget widget-shadow">
      <nz-spin [nzSpinning]="loading">
        <div class="p-20">

          <h2 class="heading-mms">Today's Summary / Activities</h2>

          <nz-timeline class="d-b p-t-30" style="min-width: 412px">

            <nz-timeline-item nzColor="blue">
              <p>
                <!-- <nz-avatar nzSize="small" nzIcon="user"
                           nzSrc="https://randomuser.me/api/portraits/men/33.jpg"></nz-avatar> -->
                Data Entry completed for 
                <nz-tag [nzColor]="'blue'">P0310151</nz-tag>
              </p>
            </nz-timeline-item>

            <nz-timeline-item nzColor="blue">
              <p>
                <!-- <nz-avatar nzSize="small" nzIcon="user"
                           nzSrc="https://randomuser.me/api/portraits/women/33.jpg"></nz-avatar> -->
                P0310084 Reassigned to user
                <nz-tag [nzColor]="'blue'">James Tello</nz-tag>
              </p>
            </nz-timeline-item>

            <nz-timeline-item>
              <p>
                <!-- <nz-avatar nzSize="small" nzIcon="user"
                           nzSrc="https://randomuser.me/api/portraits/men/74.jpg"></nz-avatar> -->
                Michael Hendrix's
                <b data-href="javascript:void(0)">Health Policy (P0301110)</b> is pending premium payment
              </p>
            </nz-timeline-item>

            <nz-timeline-item>
              <p>
                <!-- <nz-avatar nzSize="small" nzIcon="user"
                           nzSrc="https://randomuser.me/api/portraits/men/10.jpg"></nz-avatar> -->
                Verification completed for
                <nz-tag [nzColor]="'blue'">P0302190</nz-tag>

              </p>
            </nz-timeline-item>

          </nz-timeline>
        </div>
      </nz-spin>
    </div>

    <div class="widget widget-shadow">
      <h5 class="d-b p-t-b-10">SLA</h5>
      <div class="widget-wrapper" *ngIf="widgetReady">
        <div class="widget-responsive">
          <ngx-charts-bar-vertical-normalized
            [scheme]="colorScheme"
            [results]="multi"
            [gradient]="gradient"
            [xAxis]="showXAxis"
            [yAxis]="showYAxis"
            [legend]="showLegend"
            [showXAxisLabel]="showXAxisLabel"
            [showYAxisLabel]="showYAxisLabel"
            [xAxisLabel]="''"
            [yAxisLabel]="''"
            (select)="onSelect($event)">
          </ngx-charts-bar-vertical-normalized>
        </div>
      </div>
    </div>

  </div>

  <div class="m-t-10">
    <div class="w-100-pc">
      <div class="widget widget-shadow">
        <div class="flexie-auto-grid">
          <!-- HEADING -->
          <div>
            <!--<h5 class="d-b p-t-b-10">
                <nz-select nzShowSearch nzPlaceHolder="Choose" [ngModel]="'staff'">
                  <nz-option nzValue="staff" nzLabel="Staff"></nz-option>
                  <nz-option nzValue="investigator" nzLabel="Investigator"></nz-option>
                </nz-select>
              </h5>-->
          </div>
          <!-- SEARCH -->
          <div class="text-a-right p-b-10">
            <nz-input-group [nzSuffix]="suffixIconSearch" style="max-width: 260px">
              <input type="text" nz-input placeholder="Search" [(ngModel)]="searchTerm"
                (ngModelChange)="agentSearch()" />
            </nz-input-group>
            <ng-template #suffixIconSearch>
              <i *ngIf="!searchTerm" class="anticon anticon-search"></i>
              <i *ngIf="searchTerm" (click)="searchTerm=null" nzTheme="fill"
                class="ant-input-clear-icon anticon anticon-close-circle"></i>
            </ng-template>
          </div>
        </div>
        <nz-table *ngIf="widgetReady" #basicTable [nzData]="slaDataSet" nzSize="small" [nzShowPagination]="false"
          class="d-b" [nzScroll]="{x: '480px'}" [nzLoading]="isSearching">
          <thead>
            <tr>
              <th></th>
              <th>Name</th>
              <th>Tasks</th>
              <th>Completed</th>
              <th>Registration</th>
              <th>Adjudication</th>
              <th>Payout</th>
              <th>Average SLA</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let u of basicTable.data">
              <td>
                <!-- Low Load -->
                <nz-avatar *ngIf="'low'==getUserLoad(u)" style="color:#FFF; background-color:#66a355;" nzSize="default"
                  nzIcon="anticon anticon-user" nz-tooltip [nzTitle]="'Low load'"></nz-avatar>
                <!-- Moderate Load -->
                <nz-avatar *ngIf="'med'==getUserLoad(u)" style="color:#FFF; background-color:rgba(237,104,0,0.6);"
                  nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTitle]="'Moderate load'"></nz-avatar>
                <!-- Heavy load -->
                <nz-avatar *ngIf="'hig'==getUserLoad(u)" style="color:#FFF; background-color:rgba(238,90,35,0.98);"
                  nzSize="default" nzIcon="anticon anticon-user" nz-tooltip [nzTitle]="'High load'"></nz-avatar>
              </td>
              <td>
                {{u.name}}
                <nz-progress nz-tooltip [nzTitle]="u.completed+' of '+ u.tasks+' done'" nzSize="small"
                  [nzPercent]="u.completed/u.tasks*100" [nzShowInfo]="false"></nz-progress>
              </td>
              <td>{{u.tasks}}</td>
              <td>{{u.completed}} <span class="d-b f-s-tiny col-grey-dark">Avg SLA: 5h</span></td>
              <td>{{u.pendingInt}} <span class="d-b f-s-tiny col-grey-dark">Avg SLA: 2.5h</span></td>
              <td>
                {{u.pendingAdj}}
                <span class="d-b f-s-tiny-alt col-grey-dark">Pending Referral: 3</span>
                <span class="d-b f-s-tiny-alt col-grey-dark">Pending Investigation: 1</span>
              </td>
              <td>{{u.pendingPay}} <span class="d-b f-s-tiny col-grey-dark">Avg SLA: 1.25h</span></td>
              <td>{{u.sla}}h
                <!--<a [routerLink]="['/app/agent-analytics']">Details</a>-->
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </div>
  </div>

  <div class="text-a-right m-t-20">
    <h4>Team Members</h4>
    <div>
      <nz-select nzShowSearch nzAllowClear nzPlaceHolder="Select" [(ngModel)]="selectedTeamMember" style="width: 260px;">
        <nz-option nzLabel="Ninad Kulkarni" nzValue="Ninad Kulkarni"></nz-option>
        <nz-option nzLabel="Abhishek Lamrood" nzValue="Abhishek Lamrood"></nz-option>
        <nz-option nzLabel="Umesh Ravariya" nzValue="Umesh Ravariya"></nz-option>
        <nz-option nzLabel="Pratima" nzValue="Pratima"></nz-option>
        <nz-option nzLabel="Mohit" nzValue="Mohit"></nz-option>
      </nz-select>
    </div>
  </div>
  <div class="m-t-10">
    <nz-table *ngIf="widgetReady" #caseDataTable [nzData]="caseDataSet" nzSize="small" [nzShowPagination]="false"
    class="d-b" [nzScroll]="{x: '480px'}" [nzLoading]="false">
    <thead>
      <tr>
        <!-- <th></th> -->
        <th>Policy No</th>
        <th>{{appMetadataHandler.SI_LABEL}}</th>
        <th>Status</th>
        <th>Holding Time</th>
        <th>Remaining Time</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let u of caseDataTable.data">
        <td>
          {{u.name}}
          <!-- <nz-progress nz-tooltip [nzTitle]="u.completed+' of '+ u.tasks+' done'" nzSize="small"
            [nzPercent]="u.completed/u.tasks*100" [nzShowInfo]="false"></nz-progress> -->
        </td>
        <td>{{u.claimValue | CurrencyFormatter: (u.currencyCd || appMetadataHandler.productCurrencyCd ||  appMetadataHandler.companyCurrencyCd || appMetadataHandler.currentCountryCdValue)}}</td>
        <td>
          <span *ngIf="u.color=='green'" style="color: lawngreen;">{{u.status}}</span>
          <span *ngIf="u.color=='orange'" style="color: orange;">{{u.status}}</span>
          <span *ngIf="u.color=='red'" style="color: red;">{{u.status}}</span>
        </td>
        <td>{{u.holdingTm}} hrs</td>
        <td>
          {{u.pendingTm}} hrs
        </td>
      </tr>
    </tbody>
  </nz-table>
  </div>

</div>



<nz-modal [(nzVisible)]="isRetrainModelPopup" nzTitle="Retrain Model" (nzOnCancel)="cancelRetrainModelPopup()"
  (nzOnOk)="callToRetrainModel()" nzOkText="Proceed">
  <ng-container *nzModalContent>
  <p class="text-a-center">Please enter the OTP sent to your registered email id xyz@abc.com</p>
  <div class="text-a-center">
    <nz-input-group [nzSuffix]="suffixTemplate" style="width: 200px;">
      <input [type]="passwordVisible ? 'text' : 'password'" nz-input placeholder="OTP" [(ngModel)]="enteredOTP"
        autocomplete="off" />
    </nz-input-group>
    <ng-template #suffixTemplate>
      <i nz-icon [nzType]="passwordVisible ? 'eye-invisible' : 'eye'" (click)="passwordVisible = !passwordVisible"></i>
    </ng-template>
  </div>
</ng-container>
</nz-modal>